import React, { useEffect, useState } from 'react'
import { MdEdit } from "react-icons/md";
import { RiDeleteBin6Line } from "react-icons/ri";
import { useNavigate } from 'react-router-dom';
import Cookies from "js-cookie";
import { useTranslation } from 'react-i18next';
import './NotificationList.scss';
import { Image_Url } from '../../constants/imageUrl/ImageUrl';
import { getNotificationListAction } from '../../actions/NotificationAction';
import { useDispatch, useSelector } from 'react-redux';
import Loader from "../../component/loaderComponent/Loader";
import NodataFound from '../../component/NodataFound';
import Paginations from "../../component/Pagination/PgmTextField";
import { downloadNotificationExcelAction } from '../../actions/downloadAction';

const NotificationList = () => {

    const { i18n, t } = useTranslation();
    const language = Cookies.get("language");
    const { notificationList, loading } = useSelector((state) => state.getNotificationListReducer);
    const [searchCriteria, setSearchCriteria] = useState('');
    const [searchValue, setSearchValue] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const pageSize = 10;
    const resetPage = 1
    const navigate = useNavigate();
    const dispatch = useDispatch();

    useEffect(() => {
        handleChangeLanguage(language);
        dispatch(getNotificationListAction(currentPage, pageSize));
    }, [currentPage]);

    useEffect(() => {
        if (notificationList?.count) {
            setTotalPages(Math.ceil(notificationList.count / pageSize));
        }
    }, [notificationList]);

    useEffect(() => {
        if (!searchValue) {
            dispatch(getNotificationListAction(currentPage, pageSize));
        }
    }, [searchValue]);

    const handlePageChange = (event, newPage) => {
        setCurrentPage(newPage);
        dispatch(getNotificationListAction(newPage, pageSize));
    };

    const handleChangeLanguage = (language) => {
        i18n.changeLanguage(language);
    };

    const handleSelectCriteria = (event) => {
        const selected = event.target.value;
        setSearchCriteria(selected);
        setSearchValue('');
        setCurrentPage(1);
    };

    const handleSearchValue = (event) => {
        setSearchValue(event.target.value);
    }

    const handleCreateNotification = () => {
        navigate('/create-notification')
    }

    const handleCreateNotificationExcel = () => {
        navigate('/create-notification-excel')
    }

    const handleDownloadExcel = async () => {
        try {
            const blob = await dispatch(downloadNotificationExcelAction(getQueryParams()));
    
            const url = window.URL.createObjectURL(new Blob([blob]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'Notification_List.xlsx');
            document.body.appendChild(link);
            link.click();
            link.remove();
        } catch (error) {
            console.error('Download failed:', error);
        }
    };

    const handleEdit = (notificationId) => {
        const selectedNotification = notificationList?.results?.find(item => item.id === notificationId);
    
        if (selectedNotification) {
            if (selectedNotification.attachment === null) {
                navigate(`/edit-notification/${notificationId}`);
            } else {
                navigate(`/edit-notification-excel/${notificationId}`);
            }
        }
    };

    const getQueryParams = () => {
        const params = {};
        if (searchCriteria === 'heading' && searchValue) {
            params.title = searchValue;
        } else if (searchCriteria === 'date' && searchValue) {
            params.date = searchValue;
        }
        return params;
    };

    const handleSearch = () => {
        setCurrentPage(1);
        dispatch(getNotificationListAction(1, pageSize, getQueryParams()));
    };

    const isSearchDisabled = !searchCriteria || !searchValue.trim();

    return (
        <div className='notification-list-container'>
            <div className='notification-main'>
                <div className='notification-center'>
                    <div className="header-navigation">
                        <p className="notification-list-text">TVS &gt; {t('notification.notificationList')}</p>
                    </div>
                    <div className='notification-section'>
                        <div className='search-excel-button'>
                            <div className='search-notification-input'>
                                <div className='search-notification'>
                                    <select
                                        value={searchCriteria}
                                        onChange={handleSelectCriteria}
                                        className='select-criteria'
                                    >
                                        <option value=''>{t('common.searchLabel')}</option>
                                        <option value='heading'>{t('notification.heading')}</option>
                                        <option value='date'>{t('common.date')}</option>
                                    </select>

                                    {(searchCriteria === 'heading' || searchCriteria === '') && (
                                        <input
                                            className='input-criteria'
                                            type='text'
                                            placeholder={t('common.enterValue')}
                                            value={searchValue}
                                            onChange={handleSearchValue}
                                            disabled={!searchCriteria}
                                        />
                                    )}
                                    {searchCriteria === 'date' && (
                                        <input
                                            className='date-input'
                                            type='date'
                                            value={searchValue}
                                            onChange={handleSearchValue}
                                            disabled={!searchCriteria}
                                        />
                                    )}
                                </div>
                                <div className='search-btn'>
                                    <button className='search-button' onClick={handleSearch} disabled={isSearchDisabled}>{t('common.searchButton')}</button>
                                </div>
                            </div>
                            <div className='excel-create-btn'>
                                <div className="download-excel download-noti-excel">
                                    <button className="dexcel partner-excel-download noti-excel" onClick={handleDownloadExcel}>
                                        <img src={Image_Url.DEXCEL} className="downloads_imgdexcel" />
                                        {t('notification.downloadExcel')}
                                    </button>
                                </div>
                                <div>
                                    <button className='create-notification-button' onClick={handleCreateNotification}>{t('notification.createNotification')}</button>
                                </div>

                            </div>

                        </div>
                        <div className='create-bulk-excel'>
                            <button className='create-notification-button' onClick={handleCreateNotificationExcel}>{t('notification.createNotificationExcel')}</button>
                        </div>


                        <div className='notification-table'>
                            {loading ? (
                                <Loader />
                            ) : notificationList?.results?.length === 0 ? (
                                <NodataFound message={t('userManagement.noData')} />
                            ) : (
                                <table>
                                    <thead>
                                        <tr>
                                            <th>{t('common.sNo')}</th>
                                            <th className='user-name-column'>{t('notification.notificationHeading')}</th>
                                            <th>{t('common.date')}</th>
                                            <th>{t('common.time')}</th>
                                            <th>{t('common.action')}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {notificationList?.results?.map((notification, index) => (
                                            <tr key={notification.id}>
                                                <td>{(currentPage - 1) * pageSize + index + 1}</td>
                                                <td className='user-name-column'>{notification?.title}</td>
                                                <td>{notification?.starting_date}</td>
                                                <td>{new Date(`1970-01-01T${notification?.starting_time}`).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: true })}</td>
                                                <td className='action-btn'>
                                                    <button className='edit-btn' onClick={() => handleEdit(notification?.id)}>
                                                        <MdEdit style={{ 'verticalAlign': 'middle' }} />
                                                    </button>
                                                    {/* <button className='delete-btn'>
                                                        <RiDeleteBin6Line style={{ 'verticalAlign': 'middle' }} />
                                                    </button> */}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            )}
                            <div className="pagination-comp">
                                <Paginations
                                    count={totalPages}
                                    page={currentPage}
                                    handlePageChange={handlePageChange}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default NotificationList